export const FormLabelGeneralStylings = {
  fontFamily: "larsseit",
  fontFeatureSettings: '"ss01" on, "ss02" on',
}

export const FormLabel = {
  baseStyle: {
    ...FormLabelGeneralStylings,
  },
  sizes: {
    sm: {
      fontSize: "0.75rem",
      lineHeight: 1.6667,
    },
  },
  variants: {
    medium: {
      fontWeight: "medium",
    },
  },
  defaultProps: {
    size: "sm",
    variant: "medium",
  },
}
